import { computed, type InjectionKey, provide, reactive, type Ref } from 'vue'

export const blockerSymbol: InjectionKey<IBlocker> = Symbol('blocker')
export const isBlockedSymbol: InjectionKey<Ref<boolean>> = Symbol('isBlocked')

export interface IBlocker {
  [key: string]: boolean
}

export function useBlocker() {
  const blocker: IBlocker = reactive({})

  provide('blocker', blocker)
  provide(blockerSymbol, blocker)

  const isBlocked = computed<boolean>(() => {
    return Object.values(blocker).some(e => e)
  })

  provide('isBlocked', isBlocked)
  provide(isBlockedSymbol, isBlocked)

  return { blocker, isBlocked }
}
